module.exports = __webpack_public_path__ + "static/media/bg_btm_left.cf6dad6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_btm_left.svg
// module id = 181
// module chunks = 0